import {
  Backdrop, Card, CardContent, CardHeader, Divider, List, ListItem, Grid, ListItemText, Typography, Dialog,
  DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, FormControlLabel, Switch,
  Snackbar, MenuItem
} from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import UrunSearch from 'src/components/Selects/ProductSearch'
import HelpIcon from '@material-ui/icons/Help';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import Alert from 'src/components/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import axios from 'src/utils/axios';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  listItem: {
    cursor: 'pointer'
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

function AssertInsertDialog() {

  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [openProduct, setOpenProduct] = React.useState(false);
  const [productUyari, setProductUyari] = React.useState('');
  const [UrunData, setUrunData] = useState({});
  const [productSearch, setProductSearch] = useState('');
  const today = new Date();
  const maxYil = today.getFullYear();
  const [HomeWhiz, setHomeWhiz] = useState(false);
  const [warningOpen, setWarningOpen] = useState(false);
  const [warrantyuyariAciklama, setWarrantyUyariAciklama] = useState('');
  const [warrantyUyari, setWarrantyUyari] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [formState, setFormState] = useState([
    {
      name: 'SerialNumber',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_serino')
    },
    {
      name: 'ProductionYear',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: t('error_uyil').replace('@maxYil', maxYil)
    },
    {
      name: 'ProductionMonth',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_udonem')
    }
  ]);

  const [SerialParam, setSerialParam] = React.useState('');
  const [warrantyUyariTip, setWarrantyUyariTip] = useState();
  const localeMap = {
    tr: trLocale
  };
  const locale = localStorage.getItem('i18nextLng');
  const [GarantiData, setGarantiData] = useState({});
  const [garantiTarihi, setGarantiTarihi] = React.useState(null);
  const [GarantiTipi, setGarantiTipi] = React.useState(0);
  const [WarrantyData, setWarrantyData] = React.useState([]);


  useEffect(() => {

  }, [dispatch]);

  const setModel = param => {
    console.log(param)
  };

  function changeModel() {

  }

  const handleWarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarningOpen(false);
  };

  const GarantiTarihihandleChange = value => {
    let Deger = moment(value).format('YYYY-MM-DD');
    let job = GarantiData;
    job = {
      ...job,
      WarrantyDate: Deger
    };
    //setTask(job);
    setGarantiTarihi(Deger);
  };

  const GarantiTipihandleChange = event => {

  }

  const checkWarranty = () => {
    setLoading(true);
    axios
      .get(
        `/GetWarrantyControl/${garantiTarihi}/${GarantiTipi}/${GarantiData.ModelCode}/${GarantiData.ProductionYear}/${GarantiData.ProductionMonth}/${GarantiData.SerialNumber}/${GarantiData.BrandCode}/${GarantiData.ReceiptNo}`
      )
      .then(response => {
        const ResponseData = response.data[0];
        if (parseInt(ResponseData.ErrorCode) === 0) {
          setWarrantyUyariTip("success");
        } else {
          setWarrantyUyariTip("error");
        }
        setWarrantyUyariAciklama(ResponseData.Description);
        setWarrantyUyari(true);
        setLoading(false);
      })
      .catch(error => {
        setWarrantyData([]);
        setLoading(false);
      });
  };



  return (
    <div>
      <Card>
        <CardHeader title={t('lblAsset')} />
        <Divider />
        <CardContent className={classes.contentGaranti}>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Card className={classes.cardsMax}>
                <CardContent className={classes.content}>
                  <form>
                    <Dialog
                      open={openProduct}
                      onClose={() => setOpenProduct(false)}
                      aria-labelledby="alert-dialog-slide-title"
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogTitle id="alert-dialog-slide-title" color="primary">
                        {t('Bilgilendirme')}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                          {productUyari}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setOpenProduct(false)} color="primary">
                          {t('lblTamam')}

                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Grid container direction="row"
                      justifyContent="center"
                      alignItems="center" spacing={1}>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8} style = {{paddingTop: '25px'}}>
                        <UrunSearch
                          setModel={setModel}
                          value={
                            {
                              KUL_MODEL_KODU: UrunData.ModelCode,
                              ACIKLAMA: UrunData.Model
                            } || ''
                          }
                          searchParam={productSearch}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={3}>
                        <TextField
                          label={t('input_serino')}
                          name="SerialNumber"
                          size="small"
                          type="number"
                          disabled
                          value={UrunData.SerialNumber || ''}
                          fullWidth
                          required
                          onChange={(changeModel)}
                          variant="outlined"
                          error={
                            !formState.filter(n => n.name === 'SerialNumber')[0].valid
                          }
                          helperText={
                            formState.filter(n => n.name === 'SerialNumber')[0].valid
                              ? ''
                              : formState.filter(n => n.name === 'SerialNumber')[0]
                                .errorMessage
                          }
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          label={t('input_uyil')}
                          name="ProductionYear"
                          type="number"
                          size="small"
                          disabled
                          value={UrunData.ProductionYear || ''}
                          fullWidth
                          required
                          onChange={changeModel}
                          variant="outlined"
                          error={
                            !formState.filter(n => n.name === 'ProductionYear')[0].valid
                          }
                          helperText={
                            formState.filter(n => n.name === 'ProductionYear')[0].valid
                              ? ''
                              : formState.filter(n => n.name === 'ProductionYear')[0]
                                .errorMessage
                          }
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          label={t('input_udonem')}
                          name="ProductionMonth"
                          size="small"
                          disabled
                          value={UrunData.ProductionMonth || ''}
                          type="number"
                          fullWidth
                          required
                          onChange={changeModel}
                          variant="outlined"
                          error={
                            !formState.filter(n => n.name === 'ProductionMonth')[0].valid
                          }
                          helperText={
                            formState.filter(n => n.name === 'ProductionMonth')[0].valid
                              ? ''
                              : formState.filter(n => n.name === 'ProductionMonth')[0]
                                .errorMessage
                          }
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8}>
                        <div className={classes.text}>
                          <TextField
                            label={t('lblSerialNr')}
                            name="Barcode"
                            size="small"
                            value={SerialParam || ''}
                            fullWidth
                            onChange={e => setSerialParam(e.target.value)}
                            variant="outlined"
                          />
                          <Grid item xs={1}></Grid>
                        </div>
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  </form>


                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Card className={classes.cardsMax}>
                <Snackbar
                  open={warningOpen}
                  autoHideDuration={6000}
                  onClose={handleWarningClose}
                >
                  <Alert
                    onClose={handleWarningClose}
                    severity="warning"
                    message={t('lblOutWarrantyWarning')}
                    variant={'warning'}
                  ></Alert>
                </Snackbar>
                <Snackbar
                  open={warrantyUyari}
                  autoHideDuration={6000}
                  onClose={() => setWarrantyUyari(false)}
                >
                  <Alert
                    onClose={() => setWarrantyUyari(false)}
                    severity="warning"
                    message={warrantyUyari || ''}
                    variant={warrantyUyariTip}
                  ></Alert>
                </Snackbar>

                <Backdrop className={classes.backdrop} open={Loading}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                <CardContent className={classes.contentGaranti}>
                  <form>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <ThemeProvider theme={materialTheme}>
                          <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                          >
                            <KeyboardDatePicker
                              margin="normal"
                              color="primary"
                              size="small"
                              fullWidth
                              inputVariant="outlined"
                              id="GarantiTarihi"
                              label={t('Fatura_Tarihi')}
                              invalidDateMessage={t('hatali_tarih')}
                              format="dd.MM.yyyy"
                              variant="outlined"
                              value={garantiTarihi}
                              //disabled={readonly}
                              onChange={e => GarantiTarihihandleChange(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change date'
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Grid>
                      <Grid item xs={12} sm={10} lg={10}>
                        <TextField
                          size="small"
                          fullWidth
                          select
                          value={GarantiTipi}
                          onChange={GarantiTipihandleChange}
                          variant="outlined"
                        >
                          {WarrantyData.map(p => {
                            return (
                              <MenuItem key={p.WarrantyId} value={p.WarrantyId}>
                                {p.FieldText}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Button
                          disableElevation
                          variant="contained"
                          color="primary"
                          size="small"
                          fullWidth
                          //disabled={garantiTarihi === '' || GarantiData.ProductionYear === 0 || GarantiData.ProductionMonth === 0 || GarantiData.ModelCode === 0 || GarantiData.SerialNumber === 0 || GarantiData.BrandCode === 0}
                          endIcon={<CheckCircleOutlineIcon>Check</CheckCircleOutlineIcon>}
                          onClick={() => { checkWarranty() }}
                        >
                          {t('lblCheck')}
                          
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

AssertInsertDialog.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }), {
})(AssertInsertDialog);
